<script lang="ts">
    import {readyToBeContactedCompleted} from "../services/NavigationService";
    import {
        getApplicationsForUser,
        storeUserApplicationList,
        submitApplication
    } from "../services/ApplicationDataService";
    import {StoredApplicationData, StoredApplicationDataList} from "../services/Store";
    import {get} from "svelte/store";
    import {SetFatalError} from "../services/ErrorService";

    const finishAndSubmitApplication =  () => {
        const application = get(StoredApplicationData);

        if (application) {
            submitApplication(application.applicationId).then(() => {
                readyToBeContactedCompleted();
            }).catch((error) => {
                SetFatalError();
            })
        }
    }
</script>

<div class="readyToBeContacted">
    <div class="card-no-border">
        <h1>You're Almost Done</h1>
        <hr />
        <div>
            If you have completed the online review of your portion of the online application, click the 'Contact me'  button below.  A TeleLife representative will call you to finalize the
            remainder of your application. You will receive a call from 888-800-6608 within a day from a representative.
        </div>
        <div style="margin: 20px 0 20px 0;">
            If you'd like to review your application a bit more, simply click on one of the above sections and review.
            <p>
                Please remember to come back and click the 'Contact Me' button once you are ready!
            </p>
        </div>

        <div>
            <button class="pl-cta-primary" on:click={finishAndSubmitApplication}>Contact me</button>
        </div>
    </div>
</div>


<style lang="scss">
  @use "../../component_scss_library/fonts" as fonts;
  @use "../../component_scss_library/layout" as layout;
  @use "../../component_scss_library/buttons" as buttons;

  .readyToBeContacted {
    @include fonts.primary;
  }
</style>
